export class DiagramMappings {
    displayText: string;
    abbreviation: string;
    value: string;
    toolTip: string;

    constructor(displayText: string = null, abbreviation: string = null, value: string = null, toolTip: string = null) {
        this.displayText = displayText;
        this.abbreviation = abbreviation;
        this.value = value;
        this.toolTip = toolTip;
    }
}
